import { defineMessages } from "react-intl"

/**
 * All bundles for intl charts
 */
export default defineMessages({
  all: {
    id: "word.chart.all",
    defaultMessage: "CREATION"
  },
  day: {
    id: "word.chart.day",
    defaultMessage: "{count} day(s)"
  },
  hour: {
    id: "word.chart.hour",
    defaultMessage: "{count} hour(s)"
  },
  millisecond: {
    id: "word.chart.millisecond",
    defaultMessage: "{count} ms"
  },
  minute: {
    id: "word.chart.minute",
    defaultMessage: "{count} min."
  },
  month: {
    id: "word.chart.months",
    defaultMessage: "{count} month(s)"
  },
  second: {
    id: "word.chart.second",
    defaultMessage: "{count} sec."
  },
  week: {
    id: "word.chart.week",
    defaultMessage: "{count} week(s)"
  },
  year: {
    id: "word.chart.year",
    defaultMessage: "{count} year(s)"
  },
  ytd: {
    id: "word.chart.ytd",
    defaultMessage: "YTD"
  },
  january: {
    id: "word.month.january",
    defaultMessage: "January"
  },
  february: {
    id: "word.month.february",
    defaultMessage: "February"
  },
  march: {
    id: "word.month.march",
    defaultMessage: "March"
  },
  april: {
    id: "word.month.april",
    defaultMessage: "April"
  },
  may: {
    id: "word.month.may",
    defaultMessage: "May"
  },
  june: {
    id: "word.month.june",
    defaultMessage: "June"
  },
  july: {
    id: "word.month.july",
    defaultMessage: "July"
  },
  august: {
    id: "word.month.august",
    defaultMessage: "August"
  },
  september: {
    id: "word.month.september",
    defaultMessage: "September"
  },
  october: {
    id: "word.month.october",
    defaultMessage: "October"
  },
  november: {
    id: "word.month.november",
    defaultMessage: "November"
  },
  december: {
    id: "word.month.december",
    defaultMessage: "December"
  },
  monday: {
    id: "word.weekday.monday",
    defaultMessage: "Monday"
  },
  tuesday: {
    id: "word.weekday.tuesday",
    defaultMessage: "tuesday"
  },
  wednesday: {
    id: "word.weekday.wednesday",
    defaultMessage: "wednesday"
  },
  thursday: {
    id: "word.weekday.thursday",
    defaultMessage: "thursday"
  },
  friday: {
    id: "word.weekday.friday",
    defaultMessage: "friday"
  },
  saturday: {
    id: "word.weekday.saturday",
    defaultMessage: "saturday"
  },
  sunday: {
    id: "word.weekday.sunday",
    defaultMessage: "sunday"
  }
})
